import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientCallbacksTab } from '../clients/tabs/client-callbacks';
import { PageTitleService } from '../../services/page-title';

@Component({
  selector: 'app-client-callbacks-page',
  standalone: true,
  imports: [CommonModule, ClientCallbacksTab],
  templateUrl: './client-callbacks.html',
  styleUrls: ['../clients/clients-shared.css'],
})
export class ClientCallbacksPage {
  readonly pageTitle = inject(PageTitleService).title;
}
